/**
 * getMostRecentlyUpdatedModelId
 *
 * Returns the most recently updated model ID from Redux state.
 * This is a source-agnostic domain function — consumers depend on the
 * function signature, not on where the data lives.
 *
 * Backed by the session RTK Slice.
 *
 * @see src/store/slices/sessionSlice.ts
 */
import { getStore } from '@/store/store-proxy';
import { selectMostRecentlyUpdatedModelId } from '@/store/slices/sessionSlice';
export const getMostRecentlyUpdatedModelId = () => {
    const state = getStore().getState();
    return selectMostRecentlyUpdatedModelId(state);
};
